import { NavLink } from "react-router-dom";
import { useAppSelector } from '../redux/hooks';
import { useEffect, useRef, useState } from 'react';
import './NavBar.scss';

const NavBar = () => {

    const [isOpen, setIsOpen] = useState(false);
    const menuRef = useRef<HTMLDivElement>(null);
    const burgerRef = useRef<HTMLDivElement>(null);
    const overlayRef = useRef<HTMLDivElement>(null);

    const loggedIn = useAppSelector((state) => state.usersR.loggedIn)
    const role = useAppSelector((state) => state.usersR.user.role)
    const username = useAppSelector((state) => state.usersR.user.username)
    const roleAdmin = role == 'ADMIN'
    const roleSuperAdmin = role == 'SUPERADMIN'
    const roleModerator = role == 'MODERATOR'
    const roleTeacher = role == 'TEACHER'
    const roleUser = role == 'USER'

    const toggleMenu = () => setIsOpen(!isOpen);
    const closeMenu = () => setIsOpen(false);

    useEffect(() => {
      const handleClickOutside = (event: MouseEvent) => {
          if (
            isOpen &&
            menuRef.current &&
            !menuRef.current.contains(event.target as Node) &&
            burgerRef.current &&
            !burgerRef.current.contains(event.target as Node) &&
            overlayRef.current &&
            overlayRef.current.contains(event.target as Node)
          ) {
            closeMenu();
          }

          // if (isOpen && menuRef.current && !menuRef.current.contains(event.target as Node)) {
          //   closeMenu();
          // }
      };

      document.addEventListener('mousedown', handleClickOutside);
      return () => {
          document.removeEventListener('mousedown', handleClickOutside);
      };
    }, [isOpen]);

    return (
        <div className="lat-navbar">
            <div className={`lat-navbar__burger ${isOpen ? 'open' : ''}`} onClick={toggleMenu} ref={burgerRef}>
              <div className="lat-navbar__burger-line"></div>
              <div className="lat-navbar__burger-line"></div>
              <div className="lat-navbar__burger-line"></div>
            </div>

            <div 
                className={`lat-navbar__overlay ${isOpen ? 'open' : ''}`}
                ref={overlayRef}
                onClick={closeMenu}
            />

            <div className={`lat-navbar__container`}>

                <div className='lat-navbar__item lat-navbar__item--persistent'>
                  <NavLink to='/' end onClick={closeMenu}>Главная</NavLink>
                </div>

                {!loggedIn ? 
                  <>
                    <div className='lat-navbar__item lat-navbar__item--persistent'>
                      <NavLink to='/sign-up-stu' onClick={closeMenu}>Заявка</NavLink>
                    </div>
                  </>
                  :
                  <>
                  </>
                }

                {loggedIn && roleUser ? 
                  <>
                    <div className='lat-navbar__item lat-navbar__item--persistent'>
                      <NavLink to='/office' onClick={closeMenu}>Личный кабинет</NavLink>
                    </div>
                  </>
                :
                <>
                </>}

                {loggedIn && (roleAdmin || roleSuperAdmin || roleModerator || roleTeacher) ?
                  <>
                    <div className='lat-navbar__item lat-navbar__item--persistent'>
                      <NavLink to='/list' onClick={closeMenu}>Ведомость</NavLink>
                    </div>
                    <div className='lat-navbar__item lat-navbar__item--persistent'>
                      <NavLink to='/subscripV2' onClick={closeMenu}>Абонемент</NavLink>
                    </div>
                  </>
                  :
                  <></>
                }

                <div className={`lat-navbar__mobile-menu ${isOpen ? 'open' : ''}`} ref={menuRef}>


                <div className='lat-navbar__item'>
                  <NavLink to='/' end onClick={closeMenu}>Главная</NavLink>
                </div>

                {!loggedIn ? 
                  <>
                    <div className='lat-navbar__item'>
                      <NavLink to='/sign-up-stu' onClick={closeMenu}>Заявка</NavLink>
                    </div>
                  </>
                  :
                  <>
                  </>
                }

                {loggedIn && roleUser ? 
                  <>
                    <div className='lat-navbar__item'>
                      <NavLink to='/office' onClick={closeMenu}>Личный кабинет</NavLink>
                    </div>
                  </>
                :
                <>
                </>}

                {loggedIn && (roleAdmin || roleSuperAdmin || roleModerator || roleTeacher) ?
                  <>
                    <div className='lat-navbar__item'>
                      <NavLink to='/list' onClick={closeMenu}>Ведомость</NavLink>
                    </div>
                    <div className='lat-navbar__item'>
                      <NavLink to='/subscripV2' onClick={closeMenu}>Абонемент</NavLink>
                    </div>
                  </>
                  :
                  <></>
                }


                  {loggedIn && (roleAdmin || roleSuperAdmin || roleModerator || roleTeacher) ?
                    <>
                      <div className='lat-navbar__item'>
                        <NavLink to='/notice-info' end onClick={closeMenu}>Инфо</NavLink>
                      </div>
                      <div className='lat-navbar__item'>
                        <NavLink to='/notice' end onClick={closeMenu}>Уведомления</NavLink>
                      </div>
                      <div className='lat-navbar__item'>
                        <NavLink to='/notice-student' onClick={closeMenu}>Ученики</NavLink>
                      </div>
                    </>
                    :
                    <></>
                  }
                  {loggedIn && (roleAdmin || roleSuperAdmin || roleModerator) ? 
                    <>
                      <div className='lat-navbar__item'>
                        <NavLink to='/sign-up' end onClick={closeMenu}>Регистрация</NavLink>
                      </div>
                      <div className='lat-navbar__item'>
                        <NavLink to='/notice-info-admin' onClick={closeMenu}>Инфо_Доп</NavLink>
                      </div>
                    </>
                  :
                  <>
                  </>}
                  {loggedIn && roleSuperAdmin ?
                    <>
                      <div className='lat-navbar__item'>
                        <NavLink to='/subscrip' onClick={closeMenu}>Новые абонементы</NavLink>
                      </div>
                      <div className='lat-navbar__item'>
                        <NavLink to='/systems' onClick={closeMenu}>Система</NavLink>
                      </div>
                    </>
                    :
                    <></>
                  }
                
                </div>

            </div>
        </div>

    );
};

export default NavBar;
